import {
	dialog as templateDialog
} from '../../../organizations/edit-template-form'

import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import Collapsible from 'scoreboard/components/collapsible'
import config from 'scoreboard/components/config'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import selects from 'scoreboard/components/selects'
import Tooltip from 'scoreboard/components/tooltip'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import Group from './group'
import GroupCascadeDialog from './group-cascade-dialog'
import GroupDialog from './group-dialog'
import groupType from './group-type'
import panelContentTemplate from './org-group-permissions-panel.hbs'
import panelGroupTemplate from './org-group-permissions-group.hbs'
import panelHeaderTemplate from './org-group-permissions-panel-header.hbs'
import directPanelHeaderTemplate from './org-group-permissions-panel-header-direct.hbs'
import templatePanelHeaderTemplate from './org-group-permissions-panel-header-template.hbs'
import OrgGroupTemplatePermissionsPanel from './org-group-template-permissions-panel'
import OrganizationTemplatePermission from 'scoreboard/organizations/organization-template-permission'

/**
 * Menu Target for adding an existing group
 */
const AddExistingGroupView = Backbone.View.extend({
	events: {
		'click .cancel': '_onCancel'
	},

	/**
	 * @param {Principal[]} options.groups
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.html(`<form>
		<div class="add-existing-group-menu">
			<label class="full-width">
				<select></select>
			</label>
		</div>
		<div class="tooltip-footer">
			<button type="button" class="button button-default cancel small">${i18n.get('common.cancel')}</button>
			<button type="submit" class="button button-primary submit small">${i18n.get('common.add')}</button>
		</div></form>`)

		this.formView = new FormView({
			el: this.el,
			guard: false,
			submit: () => this.trigger('done', selects.val(this.select))
		})

		this.select = this.$('select')
		selects.filtering(this.select, {
			options: _.map(this.options.groups, g => ({value: g.id, label: g.label}))
		})

		this.selectField = new MarkedField({
			el: this.select,
			validator: requiredValidator
		}).render()

		this.formView.start()

		return this
	},

	_onCancel: function() {
		this.trigger('cancel')
		this.remove()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.selectField], 'remove')
	}
})

/**
 * Menu with two options for adding a group (Create New, Add Existing)
 *
 * @param {Function} options.submit called when 'Add Group' is clicked
 * @param {Array} options.groups The groups that can be added
 */
const AddDirectPermissionMenu = BootslideMenu.extend({
	className: 'add-direct-permission-menu',

	menu: function() {
		var bootslideMenu = this
		return {
			label: i18n.get('admin.group.add'),
			target: [{
				contentView: Backbone.View.extend({
					events: {
						'click': '_onAddGroup'
					},

					render: function() {
						this.$el.html(`
							<span class="option-label">
								${i18n.get('admin.group.createNewGroup')}
							</span>
						`)
						return this
					},

					_onAddGroup: function(e) {
						e.stopPropagation()
						e.preventDefault()
						bootslideMenu.options.submit(e)
						this.trigger('done')
					}
				})
			}, {
				label: i18n.get('admin.groupsByOrganization.addExistingGroup'),
				contentView: Backbone.View.extend({
					render: function() {
						this.$el.html(`
							<span class="option-label">
								${i18n.get('admin.groupsByOrganization.addExistingGroup')}
							</span>
						`)
						return this
					}
				}),
				contentEndpoint: function() {
					var v = new AddExistingGroupView({groups: bootslideMenu.options.groups})
					v.on('cancel', bootslideMenu.trigger.bind(bootslideMenu, 'cancel'))
					v.on('done', bootslideMenu.trigger.bind(bootslideMenu, 'done'))
					bootslideMenu.childViews.push(v)
					return v.render().el
				}
			}],
			width: 170
		}
	}
})

/**
 * #19683 Allows group administration based on all groups with permission to
 * a single organization.
 */
const OrgGroupPermissionsForm = Backbone.View.extend({

	className: 'org-group-permissions-form',

	events: {
		'click .edit': '_onEdit',
		'click .cascade': '_onCascade',
		'click .delete': '_onDelete',
		'click .yes-info .icon-info': '_onDirectOrgTooltip',
		'click .add-direct-permission': '_onAddDirectOrgPermission',
		'click .edit-organization-template': 'onClickEditOrganizationTemplate'
	},

	/**
	 * @param {OrganizationGroupPermission.kt} options
	 */
	initialize: function(options = {}) {
		this.options = options

		const {projectId, organizationId, organizations,
			users, groups, permissions = {}, indirectGroups = []} = options

		this.projectId = projectId
		this.orgsById = _.keyBy(organizations, 'id')
		this.orgId = organizationId
		this.orgLabel = this.orgsById[organizationId]?.label
		this.indirectGroups = indirectGroups

		const buildList = (labels) => {
			let list
			if (_.includes(config.userLabelFormat, 'comma')) {
				// Spans add a right-margin when labels contain commas
				list = '<span>' + _.join(labels, '</span><span>') + '</span>'
			} else {
				list =  _.join(labels, ', ')
			}
			return list == '' ? i18n.get('common.none') : list
		}

		const buildPermissions = type => {
			const groupPermissions = permissions[type] || []
			_.each(groupPermissions, gp => {
				// If the current user is an admin of this group
				const admin = groups[gp.groupId].admin
				gp.editable = admin
				gp.deletable = type === 'explicit' && admin
			})
			return groupPermissions
		}

		this._direct = buildPermissions('explicit')
		this._cascading = buildPermissions('implicit')
		this._viewAll = buildPermissions('view-all')
		this._template = buildPermissions('rollup-tree-group')
		const groupPermissions = _.concat(
			this._direct, this._cascading, this._viewAll, this._template)
		this._groupsPermissionById = _.keyBy(groupPermissions, 'groupId')

		_.forEach(groupPermissions, gp => {
			gp.label = groups[gp.groupId].label
			gp.fullLabel = this.getGroupLabel(gp.groupId)
			gp.orgLabels = _.map(gp.orgPermissions, o => this.orgsById[o.id].label)
			gp.adminLabels = _.map(gp.admins, p => this.getPrincipalLabel(p))
			gp.memberLabels = _.map(gp.members, p => this.getPrincipalLabel(p))
			gp.memberList = buildList(gp.memberLabels)
			gp.adminList = buildList(gp.adminLabels)
		})
	},

	getGroupLabel (groupId, overrideGroupType) {
		let {label, type} = this.options.groups?.[groupId] || {}
		if (overrideGroupType) {
			// For some scenarios (like OrganizationTemplatePermissions), the
			// effective group type for the org is different than the group's
			// defined group type
			type = overrideGroupType
		}

		if (type) {
			label += ` (${groupType?.label(type)})`
		}
		return label
	},

	getPrincipalLabel (principal, overrideGroupType) {
		// #55884
		// Ensure we only encode HTML entities for users since group
		// templates do not expect escaped characters
		return principal?.type === 'user'
			? _.escape(this.options?.users?.[principal?.id])
			: this.getGroupLabel(principal?.id, overrideGroupType)
	},

	render: function() {
		this.$el.empty()

		this.renderBanner()
		this.renderDirectPanel()
		this.renderCascadePanel()
		this.renderTemplateCollapsibles()
		this.renderViewAllPanel()

		let singleCollapsibles = [this.directCollapsible,
			this.cascadingCollapsible, this.viewAllCollapsible]
		_.each(singleCollapsibles, collapsible => {
			collapsible.on('toggleEnd', () => this.trigger('toggleExpandCollapse'))
		})

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	renderBanner () {
		let bannerLink = `<a class="text-link sp-navigate" href="admin/org-permissions-audit/${this.orgId}">${i18n.get('admin.orgPermissionsAudit')}</a>`
		let bannerMessage = i18n.get('admin.orgPermissionsAudit.bannerWithLink', bannerLink)
		let banner = `<div class="banner">${bannerMessage}</div>`
		this.$el.append(banner)
	},

	renderDirectPanel () {
		// Create the various panels to the right according to their type
		// direct panel
		const directLabel = i18n.get('admin.group.permission.direct', this._direct.length)
		this.directCollapsible = new Collapsible({
			header: directPanelHeaderTemplate({
				directLabel,
				toggle: true
			}),
			content: this.renderPanelContent({
				type: 'direct',
				label: directLabel,
				groups: this._direct,
				cascadable: true
			}),
			collapsed: true,
			collapsible: this._direct.length > 0
		})
		this.directCollapsible.render()
		this.$el.append(this.directCollapsible.el)
	},

	renderCascadePanel () {
		// cascading panel
		const cascadingLabel = i18n.get('admin.group.permission.cascading', this._cascading.length)
		this.cascadingCollapsible = new Collapsible({
			header: panelHeaderTemplate({
				label: cascadingLabel,
				toggle: true
			}),
			content: this.renderPanelContent({
				type: 'cascading',
				label: cascadingLabel,
				groups: this._cascading
			}),
			collapsed: true,
			collapsible: this._cascading.length > 0
		})
		this.cascadingCollapsible.render()
		this.$el.append(this.cascadingCollapsible.el)
	},

	renderViewAllPanel () {
		// view-all panel
		const viewAllLabel = i18n.get('admin.group.permission.viewAll', this._viewAll.length)
		this.viewAllCollapsible = new Collapsible({
			header: panelHeaderTemplate({
				label: viewAllLabel,
				toggle: true
			}),
			content: this.renderPanelContent({
				type: 'view-all',
				label: viewAllLabel,
				groups: this._viewAll
			}),
			collapsed: true,
			collapsible: this._viewAll.length > 0
		})
		this.viewAllCollapsible.render()
		this.$el.append(this.viewAllCollapsible.el)
	},

	renderTemplateCollapsibles () {
		this.templateCollapsibles = _.map(this.options.organizationTemplatePermissions, orgPerm => {
			let rollupTreeGroup = this.options.rollupTreeGroups[orgPerm.rollupTreeGroupId]
			let view = new OrgGroupTemplatePermissionsPanel({
				model: new OrganizationTemplatePermission(orgPerm),
				organizationId: this.options.organizationId,
				rollupTreeGroup,
				groups: this._template,
				principalLabelFunction: (p, overrideGroupType) =>
					this.getPrincipalLabel(p, overrideGroupType)
			})

			let collapsible = new Collapsible({
				header: templatePanelHeaderTemplate({
					label: view.headerLabel(),
					toggle: true,
					rollupTreeGroup
				}),
				content: view,
				collapsed: true,
				collapsible: view.principalCount() > 0
			})

			collapsible.on('toggleEnd', () => this.trigger('toggleExpandCollapse'))
			collapsible.render()
			this.$el.append(collapsible.el)
		})
	},

	renderPanelContent ({ type, label, cascadable, groups }) {
		let panelContext = {
			type,
			label,
			groups,
			cascadable,
			showCascadeButton: true
		}

		let content = $(panelContentTemplate(panelContext))
		content.find('ul').append(_.map(groups, group => {
			return panelGroupTemplate({
				panel: panelContext,
				group
			})
		}).join(''))

		return content
	},

	_reload: function() {
		// A change was made, and we don't know exactly what,
		// but because it could impact the entire state of the current view
		// we need to reload the model and re-render.
		$.get(`api/organizations/${this.orgId}/groups`).then(orgGroupPermissions => {
			this.options = orgGroupPermissions
			this.initialize(orgGroupPermissions)
			this.render()
		})
	},

	_onAdd: function() {
		appDisplay.dialog($.get('api/admin/groups/new'), newGroup => {
			this.groupDialog = new GroupDialog({
				model: new Group(_.extend({
					orgPermissions: [{
						projectId: this.projectId,
						id: this.orgId,
						label: this.orgLabel,
						cascade: false
					}]
				}, newGroup))
			})
			this.groupDialog.on('done', () => this._reload())
			return this.groupDialog
		})
	},

	_onEdit: function(e) {
		const groupId = this._getGroupId(e)
		appDisplay.dialog($.get(`api/admin/groups/${groupId}`), model => {
			this.groupDialog = new GroupDialog({model: new Group(model)})
			this.groupDialog.on('done', () => this._reload())
			return this.groupDialog
		})
	},

	_onCascade: function(e) {
		const groupId = this._getGroupId(e)
		const {cascade} = this._groupsPermissionById[groupId]
		const dialog = new GroupCascadeDialog({
			orgId: this.orgId,
			groupId,
			cascade
		})

		dialog.on('done', () => this._reload())

		appDisplay.dialog(dialog)
	},

	_onDelete: function (e) {
		e.preventDefault()
		e.stopPropagation()
		const id = this._getGroupId(e)
		const group = new Group({id})
		const {label, orgPermissions, cascade} = this._groupsPermissionById[id]
		const orgPermissionOnly = !_.isEmpty(orgPermissions)
		let message, title, danger
		if (orgPermissionOnly) {
			const {descendants=0} = this.orgsById[this.orgId]
			message = i18n.get('admin.group.permission.delete.confirmSinglePermission',
				highlight(label), highlight(this.orgLabel))
			// #55328 only show the extra message about removing permissions from
			// descendants if there are any descendants AND cascade is set to true
			if (descendants > 0 && cascade) {
				message += `  ${i18n.countMessage(
					'admin.group.permission.delete.descendants', descendants)}`
			}
			// #26995 more accurate title and button when removing permission
			title = i18n.get('admin.group.permission.remove')
			danger = i18n.get('common.remove')
		}
		const confirmation = new DeleteConfirmation({label, message, title, danger})
		confirmation.once('confirm', () => {
			if (orgPermissionOnly) {
				$.delete(`api/admin/groups/${id}/organizations/${this.orgId}`, () => {
					this.$(`.group-${id}`).remove()
					confirmation.trigger('done')
					this._reload()
				})
			} else {
				group.destroy({
					success: () => {
						Backbone.trigger('delete:domain-object', group)
						this._reload()
						confirmation.trigger('done') // close the confirmation
					}
				})
			}
		})
		appDisplay.dialog(confirmation)
	},

	_getGroupId: function(e) {
		return $(e.target).closest('.group').data('id')
	},

	_onDirectOrgTooltip: function(e) {
		const labels = this._groupsPermissionById[this._getGroupId(e)].orgLabels
		let labelList = ''
		_.each(labels, l => labelList += `<li>${_.escape(l)}</li>`)

		this.groupInfoTooltip = new Tooltip({
			attachTo: $(e.target),
			content: `
				<label>${i18n.get('admin.group.permission.usedInOtherOrg')}</label>
				<ul>
					${labelList}
				</ul>
			`,
			placement: 'below',
			extraClass: 'used-in-other-organizations-tooltip'
		}).render()
	},

	_onAddDirectOrgPermission: function(e) {
		const content = new AddDirectPermissionMenu({
			groups: this.indirectGroups,
			submit: this._onAdd.bind(this)
		})
		content.on('done', groupId => {
			$.ajax({
				method: 'POST',
				url: `api/admin/groups/${groupId}/organizations/${this.orgId}`,
				success: () => this._reload()
			})
		}).on('cancel', () => this.bootslideTooltip.remove())
		this.bootslideTooltip = new Tooltip({
			attachTo: $(e.target),
			content,
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu'
		}).render()
	},

	onClickEditOrganizationTemplate (e) {
		e.stopPropagation() // don't collapse the panel containing the button
		templateDialog(this.options.organizationId, { scrollToPermissions: true})
	},

	autoRemove: true

})

export default OrgGroupPermissionsForm

OrgGroupPermissionsForm.__filename__ = 'admin/principals/groups/org-group-permissions-form.js'
